import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';

import { PortalRoutes } from 'components/PortalRoutes/PortalRoutes';
import { settings } from 'config';
import oktaConfig from 'config/oktaConfig';

const AppPortal = () => {
  const oktaAuth = new OktaAuth(oktaConfig.oidc);
  const history = useHistory();
  const restoreOriginalUri: any = (
    _oktaAuth: any,
    originalUri = settings.APP_ORIGINAL_URI,
  ) => {
    history.replace(toRelativeUrl('/home', originalUri));
  };
  console.log('original uri', settings.APP_ORIGINAL_URI);
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <PortalRoutes />
    </Security>
  );
};
export default AppPortal;
